import ReactRailsUJS from 'react_ujs'
import '../components'
import '../stylesheets/application.css'

ReactRailsUJS.detectEvents()
